// Shared tooltip shown on invoice fields that a period lock disables (Class,
// Income account, Receivables account) in both the Invoices-by-line-item
// view and the native invoice drawer's line-items grid. FE-only guard —
// backend enforcement lands as a follow-up.
export const INVOICE_LOCKED_FIELD_TOOLTIP =
    "This invoice is locked. To unlock, go to settings > locks.";

// Shown on the native invoice drawer's Send / Create only actions when the
// invoice date falls inside a locked accounting period — posting either
// action would write a journal entry into that period. Save as draft is
// never gated on this, since a draft hasn't posted anything yet.
export const INVOICE_LOCKED_ACTION_TOOLTIP =
    "This invoice's date falls within a locked accounting period. To unlock, go to settings > locks.";

// Shown on every action that persists a native invoice draft (Save as draft,
// Review & send / Create, Create only, Save as template, Save template) when
// the computed total is negative. The backend rejects a negative total on
// create/update (defense-in-depth safeguard shared by this drawer and the MCP
// native-invoice tool), so gate the buttons client-side too rather than let
// the click round-trip to a generic "Save failed" toast.
export const NATIVE_INVOICE_NEGATIVE_TOTAL_TOOLTIP =
    "Invoice total can't be negative. Adjust the line items, tax, discount, or deposit.";
